<template>
  <div class="pageStyle">
    <ul v-for="(data, index) in dataList" :key="index">
      <div @click="jump(data.articleId, data.articleType)">
        <li
          :class="
            index !== 0 && index % 5 === 0 && index !== dataList.length
              ? 'dataItem dataItem_divider'
              : 'dataItem'
          "
        >
          <span>{{ data.articleTitle }}</span>
          <span class="time">{{ dealSubTime(data.createAt) }}</span>
        </li>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    jump: function (id, type){
      if(type === 1) {
        let that = this;
        this.$axios.getArticle(id)
          .then(res => {
            window.location.href = res.data.data.articleContent
          })
          .catch(() => {
            that.$router.replace("/notice");
        });
      } else {
        this.$router.push({ 
          path:'/article',
          query: {articleId: id}
        })
      }
    },
    dealSubTime(time) {
      return time.substring(0, time.lastIndexOf("T"));
    }
  }
};
</script>
<style lang="less" scoped>
.pageStyle {
  color: #3f3f3f;
  li {
    list-style-type: disc;
    cursor: pointer;
  }
  ul > a {
    color: inherit;
  }
  li:hover {
    list-style-type: square;
    color: #2b85e4;
  }
}
.dataItem {
  margin-left: 30px;
  margin-right: 10px;
  min-height: 30px;
  line-height: 30px;
  font-family: "微软雅黑";
  font-size: 14px;
  .time {
    float: right;
  }
}
.dataItem_divider {
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #e8eaec;
  background-position: 6px 28px;
}
</style>
